import React from 'react';

import { ReactComponent as AdEmptyStateIllustration } from '../../../assets/rebranding/feedback/empty-spaces/sem-anuncio.svg';
import { EmptyState } from '../../components/EmptyState';

export function AdEmptyState(): JSX.Element {
  function handleClick() {
    window.open('/vender/', '_blank');
  }

  return (
    <EmptyState
      Illustration={AdEmptyStateIllustration}
      title="você ainda não tem anúncios publicados"
      body="Crie o anúncio do seu carro e comece a divulgar para milhares de pessoas agora mesmo"
      buttonLabel="criar anúncio"
      buttonAction={handleClick}
    />
  );
}
